import { z } from 'zod';
import { isMobilePhone } from 'validator';

// const phoneRegex = new RegExp(
//   /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/
// );

export const passwordRegex = new RegExp(
  `^` +
    `(` +
    `(?=.*[A-Z])` + // Must contain at least one upper-case letter
    `(?=.*[a-z])` + // Must contain at least one lower-case letter
    `(?=.*[0-9])` + // Must contain at least one digit
    `(?=.*[\\W])` + // Must contain at least one non-word special character
    `(?![.\\n])` + // Cannot contain line breaks
    `.{10,72}` + // Must be at least 10 characters long, and no longer than 72 characters (the truncation point for BCrypt)
    `)?` + // Only apply the password regex validation once the user has actually started typing
    `$`
);
export const passwordRegexMessage =
  'Password must be at least 10 characters long, at least one uppercase letter, one lowercase letter, one number and one special character';

export const passwordSchema = z
  .string()
  .optional()
  .or(z.string().regex(passwordRegex, passwordRegexMessage));

export const signupSchema = z.object({
  firstName: z.string().min(2, 'First name should have at least 2 characters'),
  lastName: z.string().min(2, 'Last name should have at least 2 characters'),
  email: z
    .string()
    .email('Invalid email address')
    .min(2, 'Email address is required'),
  mobile: z.string().refine(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    (value) => isMobilePhone(value, 'en-AU'),
    'Mobile number is required'
  ),
  password: passwordSchema
  // termsAccepted: z
  //   .boolean()
  //   .refine(
  //     (value) => value === true,
  //     'You must accept the terms and conditions'
  //   )
});

export type SignUpDetails = z.infer<typeof signupSchema>;

export const contactSignUpSchema = z.object({
  account: signupSchema,
  newsletters: z.record(z.boolean()),
  selectedPlan: z.string(),
  product: z.string().optional(),
  redirect: z.string().optional()
});

export const acceptOrganisationInviteSchema = z.object({
  account: signupSchema,
  token_hash: z.string(),
  nonce: z.string(),
  type: z.string()
});

export type ContactSignUpDetails = z.infer<typeof contactSignUpSchema>;
